<app-filter-dialog #filtrarMes (onSeleccionar)="filtrarMesOnSeleccionar($event)"></app-filter-dialog>
<section class="flex justify-content-center mt-4">
	<div class="card-table col-12">
		<div class="flex flex-column gap-3">
			<div class="flex gap-3 flex-wrap align-items-center">
				<CustomTitle [title]="translations.titulo1" [showTag]="false" />
				<button pButton type="button" [label]="filtrarMesText"
					(click)="openFiltrarMesDialog()"></button>
			</div>
			<div class="titulo-subtitle flex" *ngIf="detalleActividades.length > 0">
				<CustomTitle [title]="translations.funcionario + ': '" [showTag]="false" styleClass="font-normal text-xl" />
				<CustomTitle [title]="detalleActividades[0].responsable" [showTag]="false" styleClass="font-medium text-xl" />
			</div>
			<div>
				<p-table [value]="detalleActividades" dataKey="tramiteActividadId" [paginator]="true" [rows]="size"
					[loading]="isLoading" rowExpandMode="single" styleClass="custom-table-blue">
					<ng-template pTemplate="header">
						<tr customHeader [columns]="columns">
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-item let-expanded="expanded">
						<tr>
							<td>
								<div class="flex align-items-center">
									<button type="button" pButton [pRowToggler]="item"
										class="p-button-text p-button-rounded p-button-plain p-button-info"
										[icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
								</div>
							</td>
              <td>{{ item.tramite }}</td>
              <td>{{ item.actividad }}</td>
              <td>{{ item.fechaTramite | date:defaultDateFormat}}</td>
              <td>
                <p-tag [value]="item.estado"
                       [severity]="getTramiteEstadoTagSeverity(item.estado)"
                ></p-tag>
              </td>
							<td>{{ item.fechaInicioProgramada | date:defaultDateFormat}}</td>
							<td>{{ item.fechaFinProgramada | date:defaultDateFormat}}</td>
							<td>{{ item.fechaInicioEjecutada | date:defaultDateFormat}}</td>
							<td>{{ item.fechaFinalReal | date:defaultDateFormat}}</td>
							<td>{{ item.diasRetraso }}</td>
							<td>{{ item.observaciones }}</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-item>
						<tr class="table-dropdown-background">
							<td colspan="12" class="pt-0">
								<div class="px-3 pb-3 pt-0">
									<app-seguimientos-historial [actividadId]="item.tramiteActividadId"
                                              class="app-card mx-auto border-1 border-top-none border-noround-top" />
								</div>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>
</section>
